import { SectionHead } from "@/components/site/SectionHead";

// REVIEW: sample summaries — verify accuracy and dates with counsel before launch.
const UPDATES = [
  { tag: "Legislation", title: "Florida property insurance reforms", body: "Recent reforms changed attorney-fee rules and shortened claim-notice windows for property policies. Timely, well-documented notice matters more than ever." },
  { tag: "Litigation", title: "Tort reform & negligence standards", body: "Changes to comparative negligence and filing timelines affect premises-liability exposure for owners and associations." },
  { tag: "Condominiums", title: "Condo safety & reserve requirements", body: "Milestone inspections and structural reserve studies now shape board obligations, budgets, and documentation." },
  { tag: "Season", title: "Hurricane season preparedness", body: "Atlantic hurricane season runs June 1 – November 30. Pre-season condition documentation creates your strongest baseline." },
];

export const FloridaUpdates = () => (
  <section id="florida-updates" className="relative py-20 sm:py-24 md:py-32 btr-bg-glow overflow-hidden" data-testid="florida-updates-section">
    <div className="relative max-w-7xl mx-auto px-6">
      <SectionHead
        badge="Florida Updates"
        title={<>The Florida risk landscape, <span className="text-[#a2020b]">briefed</span>.</>}
        lede="Regulatory and market shifts that affect owners, boards, and counsel. Summaries are educational and not legal advice."
      />
      <div className="grid sm:grid-cols-2 gap-4 mt-12">
        {UPDATES.map((u, i) => (
          <article key={u.title} className="btr-reveal btr-glass rounded-lg p-7 relative overflow-hidden hover:border-[#a2020b]/45 transition-colors" style={{ transitionDelay: `${i * 60}ms` }} data-testid={`florida-update-${i}`}>
            <span className="absolute left-0 top-7 bottom-7 w-[2px] bg-[#a2020b]" />
            <span className="inline-block font-display text-[10px] tracking-[0.25em] uppercase text-[#ff4d55] border border-[#a2020b]/40 rounded-full px-2.5 py-1">{u.tag}</span>
            <h3 className="font-display font-bold text-white text-lg sm:text-xl mt-4 tracking-tight">{u.title}</h3>
            <p className="font-body text-zinc-400 text-sm mt-3 leading-relaxed">{u.body}</p>
          </article>
        ))}
      </div>
    </div>
  </section>
);
